function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVietnamese(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 35,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M196.641 85.337H0v341.326h512V85.337z",
    style: {},
    fill: "#d80027",
    "data-original": "#d80027",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 157.279 22.663 69.747H352l-59.332 43.106 22.664 69.749L256 296.774l-59.332 43.107 22.664-69.749L160 227.026h73.337z",
    style: {},
    fill: "#ffda44",
    "data-original": "#ffda44",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVietnamese);
export default __webpack_public_path__ + "static/media/vietnamese.d0ff9e8c29a4fd32d480a6305e5096a6.svg";
export { ForwardRef as ReactComponent };